export default __webpack_public_path__ + "static/media/person.04e04b11.jpg";